import { Container, styled } from "@mui/material";

export const MuiContainer = styled(Container)``;

export const Blocks = styled('div')`

    & > .block {
        margin-bottom: 1.25rem;
    }
`;